export const DashboardTabs = {
  extends: 'Grid',
  templateColumns: '3fr 7fr',
  gap: 'A',
  // Adaptive (was fixed 'white') — inherited default ink for the Hgroup
  // heading/paragraph, which render on the normal adaptive document surface.
  color: 'title',
  align: 'space-between',
  round: 'radiusCard',
  minHeight: 'G1',
  '@screenM': {
    templateColumns: '2.7fr 7fr'
  },
  '@screenS': {
    templateColumns: '1fr'
  },
  Info: {
    flow: 'column',
    flex: 1,
    align: 'flex-start space-between',
    padding: '0',
    gap: 'E',
    '@screenS': {
      flow: 'row',
      padding: '- - Y -'
    },
    Hgroup: {
      width: '100%',
      padding: 'Z X2',
      H: {
        tag: 'h4',
        lineHeight: 1.2,
        margin: '0 0 X',
        fontWeight: '700',
        text: '{{ editor.dashboard.title | polyglot }}'
      },
      P: {
        maxWidth: 'G1',
        text: '{{ editor.dashboard.intro | polyglot }}'
      }
    },
    ContinueButton: {
      minWidth: 'auto',
      opacity: '1',
      margin: '0',
      gap: 'X2',
      text: '{{ editor.dashboard.gettingStarted | polyglot }}',
      href: '/init/personalize',
      transitionProperty: 'background, transform, color, background',
      theme: 'secondary',
      '@screenS': {
        alignSelf: 'flex-end'
      }
    }
  },
  Flex: {
    margin: '- - - -Z2',
    gap: 'A',
    flex: 3,
    '@screenS': {
      gap: 'A1'
    },
    '@tabletS': {
      display: 'grid',
      columns: 'repeat(3, 1fr)'
    },
    childExtends: 'ItemHighlightAlt',
    childrenAs: 'state',
    // `state` here is DOMQL's `childrenAs:'state'` wrapping for each ITEM
    // in the returned array (see smbls/packages/element/src/create.js
    // `childrenAs === 'state'`) — it has nothing to do with resolving free
    // variables inside this factory itself. This factory's own body needs
    // `el.getRootState().package` (the pattern every other package-gated
    // surface in this package uses — ProjectSection.js, YouAreConnected.js),
    // not a bare `state` — the bare read left every tile's `available`/
    // `icon`/`href` throwing `ReferenceError: state is not defined` on every
    // render (found via the tickets/fable.md CI guard, workspace-scope check
    // — packages/workspace/dist bundle, 2026-08-08).
    children: (el) => {
      const pkg = el.getRootState().package
      return [
        {
          available: pkg > 1,
          icon: pkg > 1 ? 'copywriting' : 'arrowUpRight',
          title: 'Content',
          href: pkg > 1 ? '/state' : '/pricing',
          p: 'State and content database'
        },
        {
          available: pkg > 1,
          icon: pkg > 1 ? 'pages' : 'arrowUpRight',
          title: 'Pages',
          href: pkg > 1 ? '/pages' : '/pricing',
          p: 'Pages, routes and flow of the app'
        },
        {
          icon: 'menu outline',
          title: 'Components',
          href: '/components',
          p: 'Symbols User Interface library'
        },
        {
          icon: 'tree outline',
          title: 'Design System',
          href: '/design-system',
          p: 'Design System of your brand'
        },
        {
          available: pkg > 1,
          icon: 'fn outline',
          title: 'Functions',
          href: pkg > 1 ? 'fn outline' : 'arrowUpRight',
          p: 'Browser and data functions'
        }
      ]
    }
  }
}
